<template>
    <section class="contacts">
        <section class="contacts__head">
            <h1 class="contacts__head__title">{{ $t('com.file.translation.title') }}</h1>
            <section class="contact-top__action-buttons">
                <ButtonWithIcon icon="plus-small" style="" :text="$t('com.file.translation-view.add-key')"
                    :classModified="true" @click="$store.commit('setAddTranslationModalKeyStatus', true)" />
            </section>
        </section>
        <section class="contact-top">
            <section class="contact-top__search">
                <form class="contact-top__form">
                    <section class="contact-top__form__item">
                        <SearchLabelComponent :label="$t('com.file.translation.search-key')" />
                        <SearchInputTextComponent v-model="$store.state.i18nStore.search.key"
                            :placeholder="$t('com.file.translation.search-key') + '...'" />
                    </section>
                </form>
            </section>
        </section>
        <section class="contacts__list">
            <Pagination :totalItems="$store.state.i18nStore.paginatedData.totalItems"
                :currentPage="$store.state.i18nStore.paginatedData.currentPage"
                :itemsPerPage="$store.state.i18nStore.paginatedData.itemsPerPage" @goToPage="changePage" />
            <table class="table-bootstrap table-bootstrap-striped table-bootstrap-hover">
                <thead>
                    <tr>
                        <th>{{ $t('com.file.translation-view.keys') }}</th>
                        <th v-for="(langauge, index) in $store.state.i18nStore.currentSelectedLanguages" :key="index">
                            <div class="d-flex justify-content-center align-items-center gap-2">
                                <span>{{ langauge.name }}</span>

                                <button class="esesja-modal__wraper__header__exit-btn"
                                    @click="removeLangauge(langauge)">
                                    <img src="@/assets/icons/components/exit-btn.svg" />
                                </button>
                            </div>
                        </th>
                        <th>
                            <select @change="languageSelectedHandler" v-model="currentSelectLanguage"
                                class="esesja-search-component-select__control">
                                <option v-for="(langauge, index) in availableLanguages" :key="index" :value="langauge"
                                    class="esesja-search-component-select__option"> {{ langauge.name }}
                                </option>
                            </select>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in translationKeys" :key="index">
                        <td>
                            <TranslationKeyItem :item="item" />
                        </td>
                        <td v-for="(lang, langIndex) in $store.state.i18nStore.currentSelectedLanguages"
                            :key="langIndex">
                            <TranslationValueItem :keyItem="item" :language="lang"
                                :value="getTranslation(lang, item)" />
                        </td>
                    </tr>
                </tbody>
            </table>
            <Pagination :totalItems="$store.state.i18nStore.paginatedData.totalItems"
                :currentPage="$store.state.i18nStore.paginatedData.currentPage"
                :itemsPerPage="$store.state.i18nStore.paginatedData.itemsPerPage" @goToPage="changePage" />
        </section>
        <Transition>
            <AddTranslationKeyModal v-if="$store.state.i18nStore.addTranslationModalKeyStatus" />
        </Transition>
        <Transition>
            <EditTranslationKeyModal v-if="$store.state.i18nStore.editTranslationModalKeyStatus" />
        </Transition>
    </section>
</template>
<script charset="utf-8">
// components
import ButtonWithIcon from "../../../BasicControls/ButtonWithIcon.vue";
import TranslationKeyItem from "./Parts/TranslationKeyItem.vue"
import TranslationValueItem from "./Parts/TranslationValueItem.vue";
import Pagination from "../../../BasicControls/Pagination.vue";
import AddTranslationKeyModal from "./Modals/AddTranslationKeyModal.vue"
import SearchLabelComponent from "../../../BasicControls/SearchLabelComponent.vue";
import SearchInputTextComponent from "../../../BasicControls/SearchInputTextComponent.vue";
import EditTranslationKeyModal from "./Modals/EditTranslationKeyModal.vue";
// servics
import i18nService from "../../../../services/i18n.service";
export default {
    name: "TranslationView",
    components: {
        ButtonWithIcon,
        TranslationKeyItem,
        TranslationValueItem,
        Pagination,
        AddTranslationKeyModal,
        SearchLabelComponent,
        SearchInputTextComponent,
        EditTranslationKeyModal
    },
    data() {
        return {
            allLanguages: [],
            currentSelectLanguage: null,

            search: {
                key: ""
            },
            translationKeys: []
        }
    },
    computed: {
        availableLanguages() {
            const allLanguages = [...this.allLanguages];
            return allLanguages.filter(language => {
                return !this.$store.state.i18nStore.currentSelectedLanguages.some(selectedLangauge => selectedLangauge.id === language.id);
            })
        },

        paginatedKeys() {
            const start = (this.$store.state.i18nStore.paginatedData.currentPage - 1) * this.$store.state.i18nStore.paginatedData.itemsPerPage;
            const end = start + this.$store.state.i18nStore.paginatedData.itemsPerPage;
            const keys = [...this.$store.state.i18nStore.allTranslationKeys];

            return keys.slice(start, end);
        }
    },
    watch: {
        '$store.state.i18nStore.search.key': {
            handler: function (newVal) {
                if (newVal !== "") {
                    this.$store.state.i18nStore.paginatedData.currentPage = 1;
                }
            }
        },
        '$store.state.i18nStore': {
            deep: true,
            handler: function (state) {
                const keys = [...state.allTranslationKeys];
                if (state.search.key !== "") {
                    const searchKey = state.search.key.toLowerCase();
                    const filteredKey = keys.filter(item => {
                        return item.key.toLowerCase().includes(searchKey) || item.name.toLowerCase().includes(searchKey);
                    })
                    state.paginatedData.totalItems = filteredKey.length;
                    this.translationKeys = this.paginatedData(filteredKey, state.paginatedData);
                }
                else {
                    state.paginatedData.totalItems = keys.length;
                    this.translationKeys = this.paginatedData(keys, state.paginatedData);
                }
            }
        }
    },
    async mounted() {
        try {
            this.$store.commit("showLoader");
            await this.internalFetchKeys();
            await this.internalFetchLanguages();
        }
        catch (e) {
            console.log(e);
        }
        finally {
            this.$store.commit("hideLoader");
        }
    },
    methods: {
        async internalFetchKeys() {
            await i18nService.getTranslationKeys();
        },
        async internalFetchLanguages() {
            this.allLanguages = await i18nService.getAvailableLanguages(true);
        },
        async languageSelectedHandler() {
            if (!this.currentSelectLanguage) {
                return;
            }
            if (this.$store.state.i18nStore.currentSelectedLanguages.some(item => item.id === this.currentSelectLanguage.id)) {
                return;
            }

            const translation = await i18nService.getTranslationByLanguageId(this.currentSelectLanguage.id);
            if (translation.status !== 200) {
                throw await Promise.reject(translation);
            }
            this.$store.state.i18nStore.currentSelectedLanguages.push({ ...this.currentSelectLanguage });

            this.$store.state.i18nStore.internalTranslations[this.currentSelectLanguage.id] = translation.data;

            this.currentSelectLanguage = null;
        },
        getTranslation(language, key) {
            if (!this.$store.state.i18nStore.internalTranslations) {
                return new {
                    id: null,
                    key: "",
                    value: ""
                }
            }

            if (!this.$store.state.i18nStore.internalTranslations[language.id]) {
                return new {
                    id: null,
                    key: "",
                    value: ""
                };
            }

            return this.$store.state.i18nStore.internalTranslations[language.id].find(item => item.key === key.key);
        },
        changePage(page) {
            this.$store.state.i18nStore.paginatedData.currentPage = page;
        },
        paginatedData(keys, paginatedObj) {
            const start = (paginatedObj.currentPage - 1) * paginatedObj.itemsPerPage;
            const end = start + paginatedObj.itemsPerPage;
            const internal = [...keys];

            return internal.slice(start, end);
        },
        removeLangauge(langauge) {

            if (!this.$store.state.i18nStore.currentSelectedLanguages.some(item => item.id === langauge.id)) {
                return;
            }

            if (!this.$store.state.i18nStore.internalTranslations[langauge.id]) {
                return;
            }

            this.$store.state.i18nStore.currentSelectedLanguages = this.$store.state.i18nStore.currentSelectedLanguages.filter(item => item.id !== langauge.id);

            delete this.$store.state.i18nStore.internalTranslations[langauge.id];
        }
    }
}
</script>
<style lang="scss" scoped>
@use "@/assets/scss/search-component.scss";


.contact-box__people--open {
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
}

.contact-box__people-container {
    padding: 0px;
    background: none;
    border-radius: 12px;
    margin: 0 16px
}

.contact-box__top {
    display: flex;
    align-items: center;
    padding: 10px;
    border-bottom: 1px solid #dce4ee;
    cursor: pointer;
    justify-content: space-between
}

.act-title {
    font-weight: bold;
}

.title {
    display: flex;
    flex-direction: row;
    align-items: center;
    column-gap: 10px;
}
</style>
